import { render, staticRenderFns } from "./weight.vue?vue&type=template&id=0caf5152&"
import script from "./weight.vue?vue&type=script&lang=js&"
export * from "./weight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports